export default {
  LIST (state, value) {
    state.list = value && Array.isArray(value) ? value : []
  },
  LIST_ADD (state, value) {
    if (state.list.findIndex((i) => i.id === value.id) === -1) {
      value.systems = value.system.length
      state.list.push(value)
    }
  },
  LIST_REMOVE (state, value) {
    const index = state.list.findIndex((i) => i.id === value)
    if (index !== -1) {
      state.list.splice(index, 1)
    }
  },
  LIST_UPDATE (state, value) {
    const index = state.list.findIndex((i) => i.id === value.id)
    if (index !== -1) {
      value.systems = value.system.length
      state.list.splice(index, 1, value)
    }
  },
  HEALTH (state, value) {
    state.inactive = value.inactive
    state.organizations = value.organizations
    state.organizationsOk = value.organizationsOk
    state.systems = value.systems
    state.systemsOk = value.systemsOk
    state.automatic = value.automatic
    state.manual = value.manual
    state.notBackedup = value.notBackedup
    state.overdue = value.overdue
  },
  HEALTH_SCOPE (state, value) {
    state.healthScope = value
  },
  HEALTH_LIST (state, value) {
    state.health_list = value
  },
  CLIENT_LIST (state, value) {
    state.clients = value
  },
  CURRENT (state, value) {
    // need to make a more graceful update to minimize screen disruptions
    if (value) {
      for (const prop of ['id', 'allowUpgrade', 'name', 'active', 'reenableTime', 'hasRpiClient', 'gitTagVersion']) {
        if (value[prop] !== state.current[prop]) {
          state.current[prop] = value[prop]
          state.update[prop] = value[prop]
        }
      }
      state.current.approvedGitVersions = value.approvedGitVersions
      state.current.hasClient = value.hasClient
      state.current.keyConnected = value.keyConnected
      state.current.ip = value.ip
      state.current.internalIp = value.internalIp
      state.current.lastConnection = value.lastConnection
      state.current.lastBackupLog = value.lastBackupLog
      state.current.lastLog = value.lastLog
      state.current.clientVersion = value.clientVersion
      state.current.users = value.users
      state.current.systems = value.systems
      state.current.rpiMacAddress = value.rpiMacAddress
      state.current.core_id = value.core_id
    } else {
      state.current = {
        active: false,
        allowUpgrade: false,
        gitTagVersion: '',
        approvedGitVersions: [],
        clientVersion: '',
        id: '',
        internalIp: '',
        ip: '',
        hasClient: false,
        hasRpiClient: false,
        keyConnected: false,
        lastConnection: '',
        lastLog: '',
        lastBackupLog: '',
        name: '',
        reenableTime: null,
        rpiMacAddress: '',
        systems: [],
        users: []
      }
      state.update = {
        id: '',
        name: '',
        active: false,
        allowUpgrade: false,
        gitTagVersion: '',
        reenableTime: null,
        hasRpiClient: false
      }
    }
  },
  UPDATE_NAME (state, value) {
    state.update.name = value
  },
  UPDATE_ACTIVE (state, value) {
    state.update.active = value
  },
  UPDATE_APPROVED_CLIENT_VERSION (state, value) {
    state.update.gitTagVersion = value
  },
  UPDATE_REENABLE_TIME (state, value) {
    state.update.reenableTime = value
  },
  UPDATE_HAS_RPI_CLIENT (state, value) {
    state.update.hasRpiClient = value
  },
  UPDATE_USERS (state, value) {
    state.update.users = value
  },
  UPDATE_ALLOW_UPGRADE (state, value) {
    state.update.allowUpgrade = value
  },
  UPDATE_USER_ALARM (state, value) {
    // state.update
  },
  ADD_USER (state, value) {
    state.current.users.push(value)
  },
  REMOVE_USER (state, value) {
    const index = state.current.users.findIndex((i) => i.id === value)
    if (index !== -1) {
      state.current.users.splice(index, 1)
    }
  },
  UPDATE_USER (state, value) {
    const index = state.current.users.findIndex((i) => i.id === value.id)
    if (index !== -1) {
      state.current.users.splice(index, 1, value)
    }
  },
  AVAILABLE_ORGS (state, value) {
    state.availableOrgs = value
  },
  RESET_AVAILABLE_ORGS (state, value) {
    state.availableOrgs = []
  }
}
